import { render, staticRenderFns } from "./MJButton.vue?vue&type=template&id=e3d92220&scoped=true&"
import script from "./MJButton.vue?vue&type=script&lang=js&"
export * from "./MJButton.vue?vue&type=script&lang=js&"
import style0 from "./MJButton.vue?vue&type=style&index=0&id=e3d92220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d92220",
  null
  
)

export default component.exports